package com.evoapps.evoshift.ui.user

import com.evoapps.evoshift.widgets.RegularCard
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.width
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.filled.HealthAndSafety
import androidx.compose.material3.Card
import androidx.compose.material3.CardDefaults
import androidx.compose.material3.HorizontalDivider
import androidx.compose.material3.Icon
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.platform.testTag
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.unit.dp
import com.evoapps.evoshift.domain.model.Competence
import com.evoapps.evoshift.viewmodels.MyStaffDetailsViewModel
import evoshift.composeapp.generated.resources.Res
import evoshift.composeapp.generated.resources.staff_competence
import evoshift.composeapp.generated.resources.staff_medical_valid_until
import evoshift.composeapp.generated.resources.staff_my_details
import evoshift.composeapp.generated.resources.staff_notes_title
import evoshift.composeapp.generated.resources.staff_ohs_training_date
import evoshift.composeapp.generated.resources.staff_ohs_valid_until
import org.jetbrains.compose.resources.stringResource

const val MY_STAFF_DETAILS_TAG = "my_staff_details"

/**
 * Profile (SH-47): what each of my workplaces keeps about me: supervision, my
 * medical exam and OHS dates, availability notes. Read-only; nothing when there is nothing.
 */
@Composable
fun MyStaffDetailsCard(viewModel: MyStaffDetailsViewModel) {
    val items by viewModel.state.collectAsState()
    if (items.isEmpty()) return
    // SH-213: the profile's card surface (RegularCard), like its menu rows.
    RegularCard(modifier = Modifier.fillMaxWidth().testTag(MY_STAFF_DETAILS_TAG)) {
        Column(Modifier.padding(16.dp), verticalArrangement = Arrangement.spacedBy(8.dp)) {
            Row(verticalAlignment = Alignment.CenterVertically) {
                Icon(Icons.Default.HealthAndSafety, contentDescription = null, tint = MaterialTheme.colorScheme.primary)
                Spacer(Modifier.width(8.dp))
                Text(stringResource(Res.string.staff_my_details), fontWeight = FontWeight.Bold)
            }
            items.forEachIndexed { index, item ->
                if (index > 0) HorizontalDivider()
                if (items.size > 1 || item.workplaceName.isNotBlank()) {
                    Text(item.workplaceName, style = MaterialTheme.typography.titleSmall, fontWeight = FontWeight.Bold)
                }
                if (item.engagement.competence == Competence.NEEDS_SUPERVISION) {
                    StatusDataRow(stringResource(Res.string.staff_competence), item.engagement.competence.label(), null)
                }
                item.record?.let { record ->
                    StatusDataRow(
                        stringResource(Res.string.staff_medical_valid_until),
                        dateWithStatus(record.medicalExamValidUntil, item.readiness?.medical),
                        item.readiness?.medical
                    )
                    record.ohsTrainingDate?.let { StatusDataRow(stringResource(Res.string.staff_ohs_training_date), formatDay(it), null) }
                    StatusDataRow(
                        stringResource(Res.string.staff_ohs_valid_until),
                        dateWithStatus(record.ohsValidUntil, item.readiness?.ohs),
                        item.readiness?.ohs
                    )
                }
                item.notes?.takeIf { it.isNotBlank() }?.let { notes ->
                    Text(stringResource(Res.string.staff_notes_title), style = MaterialTheme.typography.labelMedium)
                    Text(notes, style = MaterialTheme.typography.bodyMedium)
                }
            }
        }
    }
}
